import * as GridCell from '@progress/kendo-react-grid'
import React from 'react'
import * as IsActive from '../../components/is_active'

export class ActiveCell extends GridCell.GridCell {
  private eventName: string = ''
  private disabled: boolean = false
  private smallSlider: boolean = false

  constructor(
    props: GridCell.GridCellProps,
    eventName: string,
    disabled: boolean = false,
    smallSlider: boolean = false,
  ) {
    super(props)
    this.eventName = eventName
    this.disabled = disabled
    this.smallSlider = smallSlider
  }

  public render() {
    return <td className={`active-toggle ${this.smallSlider ? 'small-slider' : ''}`}>
      <IsActive.ToggleButton event={this.eventName}
                             id={this.props.dataItem.id}
                             is_active={this.props.dataItem[this.props.field]}
                             props={this.props}
                             disabled={this.disabled}/>
    </td>
  }

}



// WEBPACK FOOTER //
// ./src/pages/grid-cell/active_cell.tsx